import generatedContent from '@/generated/content-index.json'
import type { Article, GeneratedContent } from '@/domain/article'

const content = generatedContent as GeneratedContent

const byNewest = (a: Article, b: Article) =>
  new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()

export const getAllArticles = () => [...content.articles].sort(byNewest)

export const getLatestArticles = (limit: number) => getAllArticles().slice(0, limit)

export const getArticleBySlug = (slug: string) => getAllArticles().find((article) => article.slug === slug)

export const getArticleSlugs = () => getAllArticles().map((article) => article.slug)
